import { useState } from 'react'
import {
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'

export const CredentialModal = ({ selectedClient }) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showError, setShowError] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleLogin = async () => {
    setLoading(true)
    setShowError(false)

    try {
      if (!selectedClient?.system) {
        throw new Error('No se pudo determinar el sistema.')
      }

      const backendUrl =
        process.env.REACT_APP_ACCESO_API_URL || 'http://localhost:3003'

      const resp = await fetch(`${backendUrl}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usuario: username,
          clave: password,
          sistema: selectedClient.system,   
        }),
      })

      const data = await resp.json()

      if (!resp.ok || !data.success) {
        throw new Error(data.message || 'Error en el inicio de sesión')
      }

      window.location.replace(data.redirectUrl)  
    } catch (err) {
      console.error(err)
      setShowError(true)
    } finally {
      setLoading(false)
    }
  }


  return (
    <>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="username"
          label="Usuario"
          type="text"
          fullWidth
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          margin="dense"
          id="password"
          label="Contraseña"
          type="password"
          fullWidth
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {showError && (
          <Typography color="error" sx={{ mt: 2 }}>
            Credenciales incorrectas. Por favor, intenta de nuevo.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleLogin}
          style={{ backgroundColor: '#ff735c', color: 'white' }}
          disabled={loading}
        >
          {loading ? 'Cargando...' : 'Acceder'}
        </Button>
      </DialogActions>
    </>
  )
}
